<template>
  <el-select v-model="value" :loading="loading">
    <el-option v-for="item in options" :key="item.value" :label="item.title" :value="item.id"></el-option>
  </el-select>
</template>

<script>
export default {
  name: "y_choose_cate",
  props:{
    cate_id: {
      type:Number,
      default:0
    }
  },
  model:{
    prop:"cate_id",
    event:"change"
  },
  watch:{
    value(e){
      this.$emit("change",e)
    },
    cate_id(e){
      if(this.cate_id > 0){
        this.value = e;
      }
    }
  },
  data(){
    return{
      value:"",
      options:[],
      loading: false,
    }
  },
  mounted() {
    this.loadOpt();
  },
  methods:{
    loadOpt(){
      this.$u.api.shop.plugin.knowledge.cate({page:-1}).then(res=>{
        this.options = res.list;
      })
    }
  }
}
</script>

<style scoped>

</style>